import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import useLoginCheck from "../util/useLoginCheck";
import GroceryItem from "../recipes/GroceryItem";
import Spinner from "../util/Spinner";
import AutocompleteButton from "../util/AutocompleteButton";
import { createGroceryList, emailGroceryList } from "../slice/groceryListSlice";

const CreateGroceryList = ({
  closePopup,
  recipeSids,
  requestedGroceryItems,
  measurements,
  ingredients,
}) => {
  const dispatch = useDispatch();
  const { groceryList, isLoading, error } = useSelector((state) => {
    return state?.groceryList;
  });
  const [sendingEmail, setSendingEmail] = useState(false);
  const [recipeNames, setRecipeNames] = useState([]);
  const [selectedGroceryItem, setSelectedGroceryItem] = useState("");
  const [groceryItems, setGroceryItems] = useState([]);

  const navigate = useNavigate();

  useLoginCheck();

  useEffect(() => {
    console.log("calling create grocery list");
    dispatch(
      createGroceryList({ groceryItems: requestedGroceryItems, recipeSids })
    );
  }, [dispatch]);

  useEffect(() => {
    if (groceryList) {
      console.log("setting grocery list names and items");
      setRecipeNames(groceryList?.recipeNames);
      setGroceryItems(groceryList?.groceryItems);
    }
  }, [groceryList]);

  const handleEmailGroceryList = async (e) => {
    e.preventDefault();
    try {
      setSendingEmail(true);
      console.log("emailing grocery list...");
      const resultAction = await dispatch(
        emailGroceryList({ recipeNames, groceryItems })
      );
      if (emailGroceryList.fulfilled.match(resultAction)) {
        console.log("successfully emailed grocery list!");
        navigate("/grocerylist?refresh=true");
        closePopup();
      }
    } catch (error) {
      console.log("Error emailing grocery list, message: ", error.message);
    } finally {
      setSendingEmail(false);
    }
  };

  const removeGroceryItem = (item) => {
    console.log("removing item from grocery list: ", item);
    setGroceryItems((prev) =>
      prev.filter((i) => i?.ingredient !== item?.ingredient)
    );
  };

  const updateMeasurement = (groceryItem, measurement) => {
    console.log(
      "CreateGroceryList updating " +
        groceryItem?.ingredient +
        " measurement to " +
        measurement
    );
    setGroceryItems((prevItems) =>
      prevItems.map((item) =>
        groceryItem?.ingredient === item?.ingredient
          ? {
              ...item,
              measurement,
            }
          : item
      )
    );
  };

  const updateQuantity = (groceryItem, quantity) => {
    console.log(
      "CreateGroceryList updating " +
        groceryItem?.ingredient +
        " quantity to " +
        quantity
    );
    setGroceryItems((prevItems) =>
      prevItems.map((item) =>
        groceryItem?.ingredient === item?.ingredient
          ? {
              ...item,
              quantity,
            }
          : item
      )
    );
  };

  const addGroceryItem = () => {
    const hasItem = groceryItems.some(
      (item) => item.ingredient === selectedGroceryItem
    );
    if (!hasItem) {
      console.log("Adding grocery item to list ", selectedGroceryItem);
      setGroceryItems((prevList) => [
        { ingredient: selectedGroceryItem, quantity: 1 },
        ...prevList,
      ]);
    } else {
      console.log(
        "Not adding grocery item " +
          selectedGroceryItem +
          " to list--it's already there!"
      );
    }
    setSelectedGroceryItem("");
  };

  return (
    <div className="card p-4 md:p-6 w-full">
      {isLoading ? (
        <Spinner />
      ) : (
        <form onSubmit={handleEmailGroceryList} className="space-y-4">
          <h2 className="text-lg font-semibold text-stone-800">
            Email grocery list
          </h2>
          <fieldset>
            <legend className="text-sm font-medium text-stone-500 mb-2">
              Recipes
            </legend>
            <ul className="list-disc pl-5 text-stone-800">
              {recipeNames.map((recipeName, index) => {
                return <li key={index}>{recipeName}</li>;
              })}
            </ul>
          </fieldset>
          <hr className="border-stone-200" />
          <fieldset>
            <legend className="text-sm font-medium text-stone-500 mb-2">
              Add more items
            </legend>
            {ingredients && (
              <AutocompleteButton
                items={ingredients}
                updateItems={(i) => setSelectedGroceryItem(i?.name)}
                buttonHandler={addGroceryItem}
              />
            )}
          </fieldset>
          <fieldset>
            <ul className="space-y-2">
              {groceryItems.map((groceryItem, index) => {
                return (
                  <GroceryItem
                    key={index}
                    groceryItem={groceryItem}
                    removeGroceryItem={removeGroceryItem}
                    measurements={measurements}
                    updateMeasurement={updateMeasurement}
                    updateQuantity={updateQuantity}
                  />
                );
              })}
            </ul>
          </fieldset>
          <div className="flex justify-end gap-2">
            <button onClick={closePopup} className="btn-secondary">
              Cancel
            </button>
            <button
              type="submit"
              disabled={sendingEmail}
              className="btn-primary"
            >
              {sendingEmail ? "Sending email..." : "Email list"}
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default CreateGroceryList;
